export const DARK_MODE_STORAGE_KEY = 'isDarkMode';
export enum MODE_PARAMS {
  LIGHT_CLASS = '',
  DARK_CLASS = 'dark-theme',
  LIGHT_BUNDLE = 'light-theme.css',
  DARK_BUNDLE = 'dark-theme.css',
}
